<template>
  <div class="o-card">
    <PageTitle
      :title="$t('project.add')"
      :description="$t('project.descriptionType')"
    ></PageTitle>
    <ProjectForm></ProjectForm>
  </div>
</template>

<script>
import ProjectForm from "@/components/Projects/ProjectForm.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
export default {
  components: {
    ProjectForm,
    PageTitle,
  },
};
</script>

<style></style>
